import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class METAPIService {

  baseAPIUrl: string = environment.metAPIUrl;

  constructor(
    private http: HttpClient
  ) {}

  public postLogs(params: any): Observable<void> {
    return this.http.request<void>('post', `${this.baseAPIUrl}/logs`, {
      body: params
    })
  }
}
